import * as Helper from '../shared/TSHelper';
import { BaseItem } from './BaseItem';
export class MapBase extends BaseItem {
    constructor() {
        super();
        this.address1 = null;
        this.address2 = null;
        this.city = null;
        this.state = null;
        this.postal_code = null;
    }
    getAddress() {
        return Helper.getAddress(this.address1, this.address2, this.city, this.state, this.postal_code, this.mapClassName);
    }
    getShortAddress() {
        return this.address1;
    }
    getTextAddress() {
        return [this.address1 + (this.address2 !== null && this.address2 !== '' ? ', ' + this.address2 : ''),
            this.city + ', ' + this.state + ' ' + this.postal_code].join(", ");
    }
    getMapURL() {
        let pieces = [
            this.address1,
            this.address2,
            this.city,
            this.state,
            this.postal_code
        ], finalPieces = [];
        pieces.forEach(p => {
            if (p !== null && p !== "")
                finalPieces.push(p);
        });
        const addy = encodeURIComponent(finalPieces.join(","));
        return "https://www.google.com/maps/search/?api=1&query=" + addy;
    }
}
//# sourceMappingURL=MapBase.js.map